import React from 'react';

import WithPush from 'shared/HOCs/WithPush';

import { COMPANY_PLACEHOLDERS } from './constants';

import styles from './styles.module.scss';

const NoTeamMembers = ({
  companyName,
  isServiceProvider = false,
  isInvestor = false,
  push
}) => {
  let companyPlaceholders = COMPANY_PLACEHOLDERS.company;

  if (isServiceProvider) {
    companyPlaceholders = COMPANY_PLACEHOLDERS.serviceProvider;
  } else if (isInvestor) {
    companyPlaceholders = COMPANY_PLACEHOLDERS.investor;
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        The {companyName} team haven't yet claimed the{' '}
        {companyPlaceholders.singular}.
      </div>
      <div className={styles.subtitle}>
        Know the team? Why not let them know that their{' '}
        {companyPlaceholders.singular} is listed on Unissu?
      </div>
      <div className={styles.footer}>
        Visit our{' '}
        <span
          onClick={() => push(companyPlaceholders.url)}
          className={styles.link}>
          {companyPlaceholders.link} Directory
        </span>{' '}
        to find similar {companyPlaceholders.plural} to {companyName}.
      </div>
    </div>
  );
};

export default WithPush(NoTeamMembers);
